import tinycolor from 'tinycolor2'

function LCLegendItem(props) {
  const style = props.isGradient
    ? { backgroundImage: `linear-gradient(to ${props.isHorizontal ? 'right' : 'bottom'}, ${props.color.min}, ${props.color.max}` }
    : { backgroundColor: props.color }
  const className = `lclegend__list__item 
    ${props.isHorizontal ? 'lclegend__list__item--horizontal' : ''}
    lclegend__list__item--${tinycolor(props.isGradient ? props.color.min : props.color).isDark() ? 'dark' : 'light'}`
  return (
    <li style={style} className={className}>
      {props.label}
    </li>
  )
}

export default LCLegendItem
